import { ResourceDataType } from "@/store/live-usage-mgmt/utils/types/types";

export const getUniqueAccountFromResources = (
  resources: ResourceDataType[],
) => {
  return Array.from(
    new Set(resources.map((resource) => resource.resource.account)),
  );
};
